import $ from 'jquery';
import React from 'react';
import * as API from './api';
import { withCurrentReferer } from 'plugins/contextual-back';
import ReactDOMServer from 'react-dom/server';
import { displayAcceptContractModal } from 'modules/saas/aast/case-contract/validation/accept-contract';
import { displayCaseTransferModal } from 'modules/saas/aast/common/modals/case-transfer';

export function bindModal() {
  $('#bt-accept-contract').on('click', evt => {
    const $target = $(evt.currentTarget);
    evt.preventDefault();

    displayAcceptContractModal(data => {
      const action = $target.attr('data-action');
      const method = $target.attr('data-method');

      fetch(action, {
        method: method,
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(
        res => window.location.replace(res.url),
        err => {
          console.log('Error attempting to accept contract', err);
        }
      );
    });
  });

  const displayCancelContractModal = (id, callback) => {
    const title = 'Résilier';
    const confirmationContent = `Êtes-vous sûr(e) de vouloir résilier le contrat ? Le chantier passera au statut "En attente de désinstallation". Cette action est irréversible.`;

    const renderActions = (
      <div className="actions">
        <div className="ui approve primary button">Résilier</div>
        <div className="ui cancel button">Annuler</div>
      </div>
    );

    const modal = ReactDOMServer.renderToStaticMarkup(
      <ConfirmModal
        title={title}
        content={confirmationContent}
        actions={renderActions}
      />
    );
    displayModal(modal, callback, id);
  };

  const cancelContractButton = document.getElementById('bt-cancel-contract');
  if (cancelContractButton) {
    const id = cancelContractButton.getAttribute('data-id');
    const callback = id => {
      API.cancelContract(id).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => console.log(err)
      );
    };
    cancelContractButton.onclick = () => {
      displayCancelContractModal(id, callback);
    };
  }

  $('#bt-case-transfer').on('click', evt => {
    const $target = $(evt.currentTarget);
    evt.preventDefault();

    displayCaseTransferModal(data => {
      const action = $target.attr('data-action');
      const method = $target.attr('data-method');

      fetch(action, {
        method: method,
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(
        res => window.location.replace(res.url),
        err => {
          console.log('Error attempting to accept contract', err);
        }
      );
    });
  });

  const displayDeleteCaseModal = (id, callback) => {
    const title = 'Supprimer';
    const confirmationContent = `Êtes-vous sûr(e) de vouloir supprimer le chantier ? Cette action est irréversible.`;

    const renderActions = (
      <div className="actions">
        <div className="ui approve primary button">Supprimer</div>
        <div className="ui cancel button">Annuler</div>
      </div>
    );

    const modal = ReactDOMServer.renderToStaticMarkup(
      <ConfirmModal
        title={title}
        content={confirmationContent}
        actions={renderActions}
      />
    );
    displayModal(modal, callback, id);
  };

  const deleteCaseButton = document.getElementById('bt-delete-case');
  if (deleteCaseButton) {
    const id = deleteCaseButton.getAttribute('data-id');
    const callback = id => {
      API.deleteCase(id).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => console.log(err)
      );
    };
    deleteCaseButton.onclick = () => {
      displayDeleteCaseModal(id, callback);
    };
  }
}

function displayModal(modal, callback, id) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#confirm-action-modal');

  $modal
    .modal({
      onApprove: element => {
        // Execute action and hiding it on executed
        callback(id);

        return true;
      },
    })
    .modal('show');
}

const ConfirmModal = ({ title, content, haveWarningIcon = true, actions }) => {
  const renderActions = actions ? (
    actions
  ) : (
    <div className="actions">
      <div className="ui primary approve button">Confirmer</div>
      <div className="ui cancel button">Annuler</div>
    </div>
  );
  return (
    <div id="confirm-action-modal" className="ui small modal">
      <div className="header">
        {haveWarningIcon && <i className="icon warning circle" />}
        {title}
      </div>
      <div className="content" style={{ marginBottom: '20px' }}>
        <p dangerouslySetInnerHTML={{ __html: content }} />
      </div>
      {renderActions}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/index.js